import React, {useCallback} from "react";

import {
  textColorPrimary,
  textColorSecondary,
  fontSize18,
  fontSize32,
  spacing16
} from "@churchofjesuschrist/eden-style-constants";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";

import useManagedStrings from "../../utils/use-managed-strings";
import ContentWithIcon from "../content-with-icon/content-with-icon";

const Container = styled.div`
margin-top:${spacing16};
 color: ${textColorSecondary};
  text-align:center;
`
const ErrorCode = styled.div`
  font-size: ${fontSize18};
 
`;

const ErrorMessage = styled.div`
  font-size: ${fontSize32};
  color: ${textColorPrimary};
  text-align:center;
`;


const stringGroups = [
  {
    name:"errors",
    keys: [
      "errorCode",
      "wereSorry404",
      "checkInternetConnection",
      "serverProblem",
      "unauthorized",
      "pageProblem"
    ]
  }
]
//noStrings is only set to true on the App component that is outside our strings contexts
//and only ever kicks up when we have something go wrong that may even mean strings failed to load.
//so we have a fallback strings object to use.
const noStringsObject = {
  pageProblem: "There was a problem on this page"
}

const Error = ({errorCode, noStrings = false}) => {
  const routerNavigate = useNavigate();
  const backClick = useCallback(() => routerNavigate(-1),[routerNavigate]);
  let {managedStrings} = useManagedStrings(stringGroups);
  if (noStrings) {
    managedStrings = noStringsObject;
  }

  return <Container>
    {errorCode && <ErrorCode>{managedStrings.errorCode}: {errorCode}</ErrorCode>}
    {errorCode === 404 &&
          <>
            <ErrorMessage>{managedStrings.wereSorry404}</ErrorMessage>
            <div>{managedStrings.checkInternetConnection}</div>
          </>}
    {(errorCode === 500) && <ErrorMessage>{managedStrings.serverProblem}</ErrorMessage>}
    {errorCode === 403 && <ErrorMessage>{managedStrings.unauthorized}</ErrorMessage>}
    {!errorCode && (
      <ContentWithIcon onBackClick = {backClick}>
        <ErrorMessage>{managedStrings.pageProblem}</ErrorMessage>
      </ContentWithIcon>
    )}
  </Container>
}

export default Error